export default __webpack_public_path__ + "static/media/currencyapp.94efca52.png";